import React, { memo } from "react";
import PropTypes from "prop-types";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const ChatDisableModalComponent = ({
    isOpen,
    toggle,
    title = "",
    bodyContent = "",
    footerContent = null,
    disableClose = false,
    userDetails = {},
}) => {
    const { primary = {}, secondary = {} } = userDetails;

    const getTitle = () => {
        const secondaryName = typeof secondary?.name === "string" ? secondary.name.trim() : "";
        const primaryName = typeof primary?.name === "string" ? primary.name.trim() : "";

        if (secondaryName) {
            return `${secondaryName}'s chat is disabled`;
        }
        if (primaryName) {
            return "Your chat is disabled";
        }
        return "Chat is disabled";
    };

    const getBodyContent = () => {
        const secondaryName = typeof secondary?.name === "string" ? secondary.name.trim() : "";
        const primaryName = typeof primary?.name === "string" ? primary.name.trim() : "";

        if (secondaryName) {
            return `${secondaryName} has disabled chat. You cannot start a conversation.`;
        }
        if (primaryName) {
            return "Your chat is disabled. Please contact support.";
        }
        return "Chat is disabled due to unknown reasons.";
    };

    const canClose = !disableClose ? toggle : undefined;

    return (
        <Modal isOpen={isOpen} toggle={canClose} centered>
            <ModalHeader toggle={canClose}>
                {title || getTitle()}
            </ModalHeader>
            <ModalBody>
                {bodyContent || getBodyContent()}
            </ModalBody>
            {footerContent && (
                <ModalFooter>
                    {footerContent}
                    {!disableClose && (
                        <Button color="secondary" onClick={toggle}>
                            Close
                        </Button>
                    )}
                </ModalFooter>
            )}
        </Modal>
    );
};

ChatDisableModalComponent.displayName = "ChatDisableModal";

const ChatDisableModal = memo(ChatDisableModalComponent);

ChatDisableModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggle: PropTypes.func,
    title: PropTypes.string,
    bodyContent: PropTypes.string,
    footerContent: PropTypes.node,
    disableClose: PropTypes.bool,
    userDetails: PropTypes.shape({
        primary: PropTypes.object,
        secondary: PropTypes.object,
    }),
};

export default ChatDisableModal;
